// @flow
import React, { Component } from 'react';
// types
import { type Element as ReactElement } from 'react';
import { type Location } from 'react-router';
import { type Match } from 'react-router-dom';
import { type Currencies } from '../../utilities/types';

// components
import Paginator from '../../components/Paginator';
import { DefaultIcon } from '../../components/Icon';
import TableBody from './components/TableBody';
import TableSummary from './components/TableSummary';
import TableToggle from './components/TableToggle';
// styles
import {
  XIconWrapLink,
  CustomShowModelListDiv,
  CustomModelListTable,
  SpacerDiv,
  XIconWrapDiv
} from './CrudTableStyles';
import RenderTable from './components/RenderTable';
import CustomPerPageFilter from './components/CustomPerPageFilter';

type Props = {
  //Initialize
  loadTableShowData: ({
    id: number | string,
    page: number
    // perPage: number
  }) => void,
  match: Match,
  location: Location,
  failedLoad: boolean,
  failedUpdateLoad?: boolean,
  loading: boolean,
  currencies: Currencies,

  //Paginator
  paginatorTotal?: number,
  currentPage?: number,
  changePage?: ({
    id: number | string,
    page: number
    // perPage: number
  }) => void,
  previouslyVisited?: number[],

  //PerPage Filter
  currentPerPage?: string,
  setPerPage?: () => void,
  perPageOptions?: Array<number>,

  //Summary
  TableSummaryColumn?: Array<any>,
  TableSummaryFooter?: Array<ReactElement<any> | boolean>,
  tableSummaryOptions: {
    title1: string,
    title2?: string,
    titleColor?: string,
    subTitle?: string,
    hasHorizontalRule?: boolean
  },

  //Table Body
  updateTableLoading?: boolean,
  tableData: Function,
  tableBodyOptions: {
    text: string,
    model: string,
    img: string,
    showId?: number,
    handleClose?: () => void
  },
  TableRow: Function,
  expandRow?: Function,
  expandedRow?: Function,

  //Header
  TableHeader: Function,

  //Toggle
  tableToggleOptions?: {
    sectionValue1: string,
    sectionValue2: string,
    RightAction?: ReactElement<any>,
    activeSection: string,
    handleClick: string => void,
    noFlex?: boolean
  }
};

type State = {
  prevPath: string
};
export default class CrudTableShow extends Component<Props, State> {
  state = {
    prevPath: ''
  };
  componentDidMount() {
    if (this.props.location && this.props.location.state) {
      this.setState({ prevPath: this.props.location.state.prevPath });
    }
    const id = this.props.tableBodyOptions.showId || this.props.match.params.id;
    if (id) {
      this.props.loadTableShowData({
        id,
        page: 1
        // perPage: 25
      });
    }
  }

  changePage = (page: number) => {
    const id = this.props.match.params.id;
    if (id) {
      // $FlowFixMe
      this.props.changePage({
        id,
        page
        // perPage: 25
      });
    }
  };

  handleClose = () => {
    const { handleClose } = this.props.tableBodyOptions;
    if (handleClose) {
      return (
        <XIconWrapDiv>
          <DefaultIcon
            colorName="dustyGray"
            name="x"
            onClick={() => handleClose()}
          />
        </XIconWrapDiv>
      );
    } else {
      return (
        <XIconWrapLink to={this.state.prevPath}>
          <DefaultIcon name={'x'} />
        </XIconWrapLink>
      );
    }
  };

  renderTableHeader = () => {
    if (this.props.tableToggleOptions && !this.props.updateTableLoading) {
      return <thead>{this.props.TableHeader}</thead>;
    }

    if (!this.props.tableToggleOptions && !this.props.loading) {
      return <thead>{this.props.TableHeader}</thead>;
    }
  };

  render() {
    const hasPerPageFilter =
      Boolean(!this.props.loading) &&
      Boolean(this.props.perPageOptions) &&
      this.props.tableData.length > 0;

    const hasPaginator =
      Boolean(!this.props.loading) &&
      Boolean(this.props.paginatorTotal) &&
      this.props.tableData.length > 0;

    return (
      <CustomShowModelListDiv
        hideBorderTop={this.props.tableBodyOptions.showId}
      >
        {this.handleClose()}
        <RenderTable
          failedLoad={this.props.failedLoad}
          tableBodyOptions={this.props.tableBodyOptions}
        >
          <>
            {this.props.loading || (
              // $FlowFixMe
              <TableSummary
                TableSummaryColumn={this.props.TableSummaryColumn}
                TableSummaryFooter={this.props.TableSummaryFooter}
                options={this.props.tableSummaryOptions}
              />
            )}
            {this.props.loading ||
              (this.props.tableToggleOptions ? (
                <TableToggle data={this.props.tableToggleOptions} />
              ) : (
                <SpacerDiv />
              ))}
            <>
              <CustomModelListTable hasPerPageFilter={hasPerPageFilter}>
                {this.renderTableHeader()}
                <tbody>
                  <TableBody
                    failedLoad={this.props.failedUpdateLoad || false}
                    loading={this.props.loading}
                    updateTableLoading={this.props.updateTableLoading}
                    tableData={this.props.tableData}
                    currencies={this.props.currencies}
                    TableRow={this.props.TableRow}
                    expandedRow={this.props.expandedRow}
                    expandRow={this.props.expandRow}
                    tableBodyOptions={this.props.tableBodyOptions}
                  />
                </tbody>
              </CustomModelListTable>
              {hasPerPageFilter && (
                <CustomPerPageFilter
                  currentPerPage={this.props.currentPerPage || ''}
                  // $FlowFixMe
                  setPerPage={this.props.setPerPage}
                  perPageOptions={this.props.perPageOptions || []}
                />
              )}
              {hasPaginator && (
                <Paginator
                  paginatorTotal={this.props.paginatorTotal || NaN}
                  currentPage={this.props.currentPage || NaN}
                  changePage={this.changePage}
                  previouslyVisited={this.props.previouslyVisited || []}
                />
              )}
            </>
          </>
        </RenderTable>
      </CustomShowModelListDiv>
    );
  }
}
